import React, { useState } from 'react';
import '../../assets/css/SnippetCard.css';
import { useNavigate } from "react-router-dom";
  
import cardicon from '../../assets/img/icon_snippet_card_small.png';
const SnippetMenu = ( user ) => {
    
    const [cardMenu, setCardMenu] = useState(false);
    const navigate = useNavigate();

    const returnValue = () => {
        if (user.user === undefined || user.user === null) return;
        
        return (
            <>
                <div className="snippet-card-container">
                    <button onClick={() => {setCardMenu(!cardMenu)}}><img src={cardicon} alt="" /></button>
                </div>
                {cardMenu ? (
                <div className="snippet-card-menu">
                    <div className="snippet-card-btn-container">
                        <button className="w-100 btn btn-lg btn-primary" type="button" onClick={() => {setCardMenu(!cardMenu);navigate("/createSnippet")}}>Create Snippet</button>
                    </div>
                </div>)
                : ""}
            </>
        );

    }

    return( returnValue() )
    

}

export default SnippetMenu;